import { getApiUrl } from './apiBaseUrl'

async function getData(url = '', signal) {
  const controller = new AbortController()
  const validSignal = signal instanceof AbortSignal ? signal : controller.signal
  const fullUrl = getApiUrl(url)

  const response = await fetch(fullUrl, {
    method: 'GET',
    mode: 'cors',
    cache: 'no-cache',
    credentials: 'same-origin',
    headers: {
      'Content-Type': 'application/json'
    },
    redirect: 'follow',
    referrerPolicy: 'no-referrer',
    signal: validSignal,
  })

  const responseJson = await response.json()

  if (responseJson?.redirect) {
    window.location.href = window.location.origin + responseJson.redirect
    return {}
  }

  return responseJson
}

export default getData
